import {
    ContextualMenu,
    CommandBarButton as FluentCommandBarButton,
    IButtonProps,
    IContextualMenuItem,
    Spinner,
    SpinnerSize
} from "@fluentui/react";
import React from "react";

export type CommandBarButtonProps = Pick<IButtonProps, "text" | "disabled" | "onClick" | "styles"> & {
    menuItems?: CommandBarButtonMenuItem[];
    icon?: string;
    isLoading?: boolean;
    testId?: string;
};

export interface CommandBarSubMenuItem {
    text: string;
    icon?: string;
    disabled?: boolean;
    onClick?(): void;
    testId?: string;
}

export interface CommandBarButtonMenuItem {
    text: string;
    icon?: string;
    disabled?: boolean;
    tooltipMessage?: string;
    onClick?(): void;
    subMenuProps?: { items: CommandBarSubMenuItem[] };
}

export const CommandBarButton: React.FunctionComponent<CommandBarButtonProps> = ({
    text,
    icon,
    disabled,
    isLoading,
    menuItems,
    styles,
    onClick,
    testId
}: CommandBarButtonProps) => {
    return (
        <FluentCommandBarButton
            onClick={onClick}
            text={text}
            data-testid={testId}
            disabled={disabled || isLoading}
            menuProps={
                menuItems && {
                    items: menuItems.map(
                        (item: CommandBarButtonMenuItem): IContextualMenuItem => {
                            return {
                                key: item.text.toLowerCase(),
                                text: item.text,
                                disabled: item.disabled,
                                title: item.tooltipMessage,
                                iconProps: item.icon ? { iconName: item.icon } : undefined,
                                onClick: () => (item.onClick ? item.onClick() : undefined),
                                "data-testid": `menu-item-${item.text}`,
                                subMenuProps: item.subMenuProps && {
                                    items: item.subMenuProps.items.map((i) => ({
                                        key: i.text?.toLowerCase(),
                                        text: i.text,
                                        disabled: i.disabled,
                                        iconProps: i.icon ? { iconName: i.icon } : undefined,
                                        onClick: () => (i.onClick ? i.onClick() : undefined),
                                        "data-testid": i.testId
                                    }))
                                }
                            };
                        }
                    ),
                    onRenderSubMenu: (props: any) => {
                        return <ContextualMenu {...props} />;
                    }
                }
            }
            iconProps={{ iconName: icon }}
            styles={{
                root: {
                    background: "none"
                },
                ...styles
            }}
        >
            {isLoading && <Spinner size={SpinnerSize.small} />}
        </FluentCommandBarButton>
    );
};
